"use client"

import { Tabs } from "antd"
import { useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppSelector } from "@/lib/redux/hooks"
import { SelectPlacementContext } from "."
import DomesticAirports from "./DomesticAirports"
import InternationalAirports from "./InternationalAirports"
import ResultAirports from "./ResultAirports"

type TabKey = "INTERNAL" | "EXTERNAL"

const FlightPopularDestinationTabs = () => {
  const { searching } = useContext(SelectPlacementContext)
  const searchPopular = useAppSelector((state) => state.flight.searchPopular)
  const { t } = useTranslation()
  const [activeKey, setActiveKey] = useState<TabKey>("INTERNAL")

  if (searching && !searchPopular) {
    return null
  }

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(k) => setActiveKey(k as TabKey)}
      className="flight-popular-destination-tabs"
      items={[
        {
          key: "INTERNAL",
          label: (
            <p className="flight-popular-destination-tabs__label" style={{ paddingInline: "1.2rem", margin: 0 }}>
              {t("hotel.popular_in_vietnam")}
            </p>
          ),
          children: <DomesticAirports hideSectionTitle />,
        },
        {
          key: "EXTERNAL",
          label: (
            <p className="flight-popular-destination-tabs__label" style={{ paddingInline: "1.2rem", margin: 0 }}>
              {t("hotel.internationally_popular")}
            </p>
          ),
          children: (
            <>
              <InternationalAirports hideLeadingDivider hideSectionTitle />
              <ResultAirports />
            </>
          ),
        },
      ]}
    />
  )
}

export default FlightPopularDestinationTabs
